import React from 'react';
import styles from "./BaseSimpleItemEditorHeader.module.css";
import {Divider, Typography} from "@mui/material";

const BaseSimpleItemEditorHeader = ({isAddSubMode, editItemId, customTextFunc}) => {
    return (
        <div className={styles.main}>
            <Typography variant="h6" sx={{fontWeight: "bold", marginBottom: "10px"}}>
                {customTextFunc ? customTextFunc(isAddSubMode, editItemId) : (isAddSubMode ? "Добавление новой записи" : `Редактирование записи (id=${editItemId})`)}
            </Typography>
            <Divider component="div"/>
        </div>
    );
};

export default BaseSimpleItemEditorHeader;